import { render, staticRenderFns } from "./recoveryDetail.vue?vue&type=template&id=0f4ffab4&scoped=true"
import script from "./recoveryDetail.vue?vue&type=script&lang=js"
export * from "./recoveryDetail.vue?vue&type=script&lang=js"
import style0 from "./recoveryDetail.vue?vue&type=style&index=0&id=0f4ffab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ffab4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TimeCountdown: require('/drone/src/components/TimeCountdown/index.vue').default,Recoverbox: require('/drone/src/components/recoverbox.vue').default})
